/**
 * The handful of `path.posix` functions the engine needs, reimplemented.
 *
 * Every path the engine handles is a POSIX path inside a workspace, never a
 * host path, so Node's path module was only ever borrowed for its posix half.
 * Reimplementing it is what lets this package run in a browser tab. The
 * behaviour is Node's, including the corners the file API depends on: an
 * empty path normalises to ".", a trailing slash survives, and a relative
 * path may keep leading ".." segments (which is why `resolveMissionPath`
 * still checks the result against the mission prefix afterwards).
 */
export function normalize(input) {
    if (input.length === 0)
        return '.';
    const absolute = input.startsWith('/');
    const trailingSlash = input.endsWith('/');
    const out = [];
    for (const segment of input.split('/')) {
        if (segment === '' || segment === '.')
            continue;
        if (segment === '..') {
            if (out.length > 0 && out[out.length - 1] !== '..')
                out.pop();
            else if (!absolute)
                out.push('..');
            continue;
        }
        out.push(segment);
    }
    const joined = out.join('/');
    if (joined.length === 0)
        return absolute ? '/' : trailingSlash ? './' : '.';
    return `${absolute ? '/' : ''}${joined}${trailingSlash ? '/' : ''}`;
}
export function join(...parts) {
    const present = parts.filter((p) => p.length > 0);
    return present.length === 0 ? '.' : normalize(present.join('/'));
}
/**
 * Bytes a string occupies in UTF-8, without allocating the encoding.
 *
 * Stands in for `Buffer.byteLength`. A lone surrogate counts as three bytes,
 * which is what both `Buffer` and `TextEncoder` produce for it (U+FFFD).
 */
export function utf8Length(value) {
    let bytes = 0;
    for (let i = 0; i < value.length; i++) {
        const code = value.charCodeAt(i);
        if (code < 0x80)
            bytes += 1;
        else if (code < 0x800)
            bytes += 2;
        else if (code >= 0xd800 && code <= 0xdbff && (value.charCodeAt(i + 1) & 0xfc00) === 0xdc00) {
            bytes += 4;
            i++;
        }
        else
            bytes += 3;
    }
    return bytes;
}
//# sourceMappingURL=posix.js.map